import { render, staticRenderFns } from "./ReviewQuestion.vue?vue&type=template&id=2a0fc462&"
import script from "./ReviewQuestion.vue?vue&type=script&lang=js&"
export * from "./ReviewQuestion.vue?vue&type=script&lang=js&"
import style0 from "./ReviewQuestion.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports